import http from 'plugins/axios';

export default {
    getInvitePosterList(data) {
        return http.get({
            url: '/admin/invitePoster/list',
            data
        });
    },
    createInvitePoster(data) {
        return http.post({
            url: '/admin/invitePoster/add',
            data,
            dataType: 'form'
        });
    },
    updateInvitePoster(data) {
        return http.post({
            url: '/admin/invitePoster/update',
            data,
            dataType: 'form'
        });
    },
    removeInvitePoster(id) {
        return http.post({
            url: `/admin/invitePoster/delete/`,
            data: {"id": id},
            dataType: 'form'
        });
    }
};
